import $ from 'jquery'
import 'select2'

export default () => {
    let $select = $('body form .custom-select')
    $select.select2({
        templateResult: formatState,
        templateSelection: formatState
    })

    function formatState (state) {
        let icons = $select.data('options')

        if (!state.id) { return state.text; }

        return $(
            `
            <div style="display: flex; align-items: center;">
               <div class="icon"><img sytle="display: inline-block;" src="${icons[state.text]}" style="height: 30px;width: auto;" /></div>
               <div style="margin-left: 10px;">
                  ${state.text}
               </div>
            </div>
            `
        );
    }

}
